import React from "react";
import Image01 from "../assets/profile.svg";
import { TbGridDots } from "react-icons/tb";
import { useConnection } from "../context/ConnectionContext";

const FeedFriend = ({ button, connect, info }) => {
  const { disconnect, connect: addConnection } = useConnection();
  const handleConnectionButtonClick = () => {
    if (button === 'Connect'){
      addConnection(info?.id);
    }else{
      disconnect(info?.id);
    }
  }
  return (
    <div className="flex flex-col justify-center items-center rounded-lg border pt-5 pb-3 hover:shadow-xxl hover:border-none">
      <img src={info?.profilePicture ? info?.profilePicture : Image01} alt="" />
      <p className="pt-3 text-sm font-medium">{`${info.firstName} ${info.lastName}`}</p>
      {(info.city || info.state ) && <p className="pt-1 text-xs font-normal">{info.city}, {info.state}</p>}
      <div className="flex items-center pt-1  text-[10px]">
        {button === "Connect" && (
          <div className="pr-2">
            <TbGridDots className="text-primary" />
          </div>
        )}
        <p className="font-normal">{connect}</p>
      </div>

      <button onClick={handleConnectionButtonClick} className="bg-primary text-white py-1 px-10 rounded mt-3 text-xs hover:border-2 hover:border-primary hover:bg-transparent hover:text-primary">
        {button}
      </button>
    </div>
  );
};

export default FeedFriend;
